module.exports = __webpack_public_path__ + "img/ssl.64b2b1e7.svg";